if (!customElements.get('collection-reviews')) {
  customElements.define(
    'collection-reviews',
    class CollectionReviews extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector('.swiper');
        this.wrapper = this.querySelector('.swiper-wrapper');
      }

      connectedCallback() {
        // Slides and the trust badge are server-rendered from the same
        // reviews.schema_json records that feed the collection's JSON-LD, so this
        // element only has to turn the markup into a carousel. It deliberately does
        // NOT fetch Stamped and swap the content in: doing so used to leave the page
        // showing a different set of reviews (and a different review total) from the
        // one declared in the structured data, which Google reads as markup for
        // content that is not on the page.
        if (!this.wrapper || !this.wrapper.children.length) return;

        const observer = new IntersectionObserver(
          (entries, obs) => {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            this.initSwiper();
          },
          { rootMargin: '300px' }
        );

        observer.observe(this);
      }

      initSwiper() {
        if (typeof Swiper === 'undefined' || !this.slider) return;
        if (!this.wrapper.children.length) return;

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1,
          spaceBetween: 16,
          loop: this.wrapper.children.length > 4,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            750: { slidesPerView: 2 },
            990: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          },
        });
      }
    }
  );
}
